export const SHOPS_BY_BRAND_CONTAINER_ID = 'js--shopsByBrand';
export const SHOPS_CONTAINER_ID = 'ajaxPartnerShop';